import { TApplicationsContactInformationForm } from '~/store/remote-banking-contacts/types.ts';
import {
  TManagerForm,
  TResponsiblePerson,
  TResponsiblePersonsForm,
} from '~/modules/remote-banking-contacts/type.ts';
import { formatBirthDate } from '~/modules/remote-banking-contacts/utils.ts';
import { PersonRole } from '~/modules/remote-banking-contacts/constants.tsx';

export const initialFormValues: TApplicationsContactInformationForm = {
  phoneNumber: '',
  email: '',
};

export const initialValuesManager: TManagerForm = {
  havePersonalIdentifier: null,
  contragentType: '',
  contragentIdentifier: '',
  person: {
    lastName: '',
    firstName: '',
    middleName: null,
    birthDate: '',
    personalIdentifier: null,
    documentInfo: null,
  },
};

export const initialValuesResponsiblePersons = (
  formPersons?: TResponsiblePerson[]
): TResponsiblePersonsForm => {
  if (!formPersons) {
    return {
      directors: [],
      someone: [],
    };
  }

  const mapped = formPersons.map((person) => ({
    id: person?.id || null,
    lastName: person?.lastName || '',
    firstName: person?.firstName || '',
    middleName: person?.middleName || null,
    birthDate: person?.birthDate ? formatBirthDate(String(person.birthDate)) : '',
    personalIdentifier: person?.personalIdentifier || '',
    email: person?.email || '',
    phoneNumber: person?.phoneNumber || '',
    personRole: person?.personRole || '',
    documentInfo: {
      documentType: person?.documentInfo?.documentType || 0,
      documentNumber: person?.documentInfo?.documentNumber || '',
      documentSeries: person?.documentInfo?.documentSeries || '',
    },
  }));

  const directors = mapped.filter(
    (person) =>
      person.personRole === PersonRole.DIRECTOR || person.personRole === PersonRole.SOLE_TRADER
  );

  const someone = mapped.filter(
    (person) =>
      person.personRole !== PersonRole.DIRECTOR && person.personRole !== PersonRole.SOLE_TRADER
  );

  return { directors, someone };
};
